module.exports = __webpack_public_path__ + "img/713.40088500.jpg";